import React from 'react';
import * as ReactDOM from "react-dom/client"
//import { createRoot } from "react-dom/client";
import reactToWebComponent from 'react-to-webcomponent';
import WaykeComposite from "@wayke-se/components-react";

import './index.css';
import  "@wayke-se/ecom-web/dist/index.css";

const settings = {
  composite: {
    modifyDocumentTitleItem: true,
    modifyDocumentTitleSearch: "Bilar i lager",
  },
  provider: {
    graphQlUrl: process.env.REACT_APP_WAYKE_GRAPH_QL_URL,
    url: process.env.REACT_APP_WAYKE_SEARCH_URL,
    urlMlt: process.env.REACT_APP_WAYKE_SEARCH_MLT_URL,
    ecomSettings: {
      url: process.env.REACT_APP_WAYKE_ECOM_URL,
      useBankId: true,
      serviceLogotypeUrl: "https://cdn.wayke.se/wui/images/ecom/wayke-logo.svg",
    },
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    googleMapsMarker: "https://www.wayke.se/images/map/marker.png",
    useQueryParamsFromUrl: true,
  },
};



//const container = document.getElementById("react-components");
//const root = createRoot(container);

const WaykeApp = () => {
  return (
    <WaykeComposite {...settings} />
  )
}

customElements.define("react-wayke", reactToWebComponent(WaykeApp, React, ReactDOM));

//root.render(<WaykeComposite {...settings} />);
